import {createAsyncThunk, createSlice, current} from '@reduxjs/toolkit';
import {
    deleteRateApi,
    getAllRatesApi,
    getAllRatesCardByIdApi, getAllRatesCardByIdApiWithPagination,
    postRateApi,
    postRateSearchApi,
    updateRateApi
} from "../../api/backendAPIs";

export const fetchAllRates = createAsyncThunk('fetchAllRates', async () => {
    return await getAllRatesApi("page=0&size=10000")
})

export const findAllRatesByRateCardId = createAsyncThunk('fetchAllRatesByRateCard', async (id) => {
    return await getAllRatesCardByIdApi(id)
})

export const findAllRatesByRateCardIdWithPagination = createAsyncThunk('findAllRatesByRateCardIdWithPagination', async (id) => {
    const res = await getAllRatesCardByIdApiWithPagination(id)
    return res
})

export const deleteRateById = createAsyncThunk('deleteRateById', async (payload) => {
    return deleteRateApi(payload);
})

export const postRate = createAsyncThunk('postRate', async (payload) => {
    return postRateApi(payload);
})

export const postRateSearch = createAsyncThunk('postRateSearch', async (payload) => {
    return postRateSearchApi(payload, "page=0&size=10000");
})

export const updateRate = createAsyncThunk('updateRate', async (payload) => {
    return updateRateApi(payload);
})

const initialState = {
    rates: [],
    loadingRates: false,
    searchRate: null
}

export const ratesSlice = createSlice({
    name: 'rates',
    initialState,
    reducers: {
        emptyAllRates: (state, action) => {
            state.rates = []
        }
    },
    extraReducers: {
        [fetchAllRates.pending]: (state) => {
            state.loadingRates = true;
        },
        [fetchAllRates.fulfilled]: (state, {payload}) => {
            state.loadingRates = false;
            state.rates = payload.data.content;
        },
        [fetchAllRates.rejected]: (state, {payload}) => {
            state.loadingRates = false;
        },
        [findAllRatesByRateCardId.pending]: (state) => {
            state.loadingRates = true;
        },
        [findAllRatesByRateCardId.fulfilled]: (state, {payload}) => {
            state.loadingRates = false;
            state.rates = payload;
        },
        [findAllRatesByRateCardId.rejected]: (state, {payload}) => {
            state.loadingRates = false;
            state.rates = payload.data.content;
        },
        [postRate.pending]: (state) => {
            state.loadingRates = true;
        },
        [postRate.fulfilled]: (state, {payload}) => {
            const arr = [...current(state.rates)]
            arr.push(payload.data)
            state.rates = arr
            state.loadingRates = false;
        },
        [postRate.rejected]: (state) => {
            state.loadingRates = false;
        },
        [updateRate.pending]: (state) => {
            state.loadingRates = true;
        },
        [updateRate.fulfilled]: (state, {payload}) => {
            const arr = [...current(state.rates)]
            const findIndex = arr.findIndex(i => i.id === payload.data.id)
            if (findIndex !== -1) {
                arr[findIndex] = payload.data
                state.rates = arr
            }
            state.loadingRates = false;
        },
        [updateRate.rejected]: (state) => {
            state.loadingRates = false;
        },
        [postRateSearch.pending]: (state) => {
            state.loadingRates = true;
        },
        [postRateSearch.fulfilled]: (state, {payload}) => {
            state.loadingRates = false;
            state.searchRate = payload.data.content
        },
        [postRateSearch.rejected]: (state) => {
            state.loadingRates = false;
        }
    }
});

export const ratesReducer = ratesSlice.reducer
export const {emptyAllRates } = ratesSlice.actions
